<button
    type="button"
    class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-flex-column cmps-cdk-h-100pct cmps-cdk-p-0 cmps-cdk-text-left focus:not:focus-visible:cmps-cdk-outline-none"
    (click)="click.emit()"
    *ngIf="!noSelect"
>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</button>

<div
    class="cmps-cdk-d-inline-flex cmps-cdk-flex-column cmps-cdk-h-100pct"
    *ngIf="noSelect"
>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</div>

<ng-template #contentTpl>
    <div class="cmps-cdk-flex-grow-1 cmps-cdk-py-0dot5">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold"
            [class.cmps-cdk-color-blue-100]="selected"
        >
            <ng-content
                select=".cmps-report-builder-selection-section--name"
            ></ng-content>
        </div>
        <div class="cmps-cdk-line-clamp-2">
            <ng-content
                select=".cmps-report-builder-selection-section--selection"
            ></ng-content>
        </div>
    </div>
    <div
        class="cmps-cdk-h-4px"
        [class.cmps-cdk-bg-color-blue-100]="selected"
    ></div>
</ng-template>
